export const formatDuration = (duration: number = 0) => {
  return new Date(duration * 1000).toISOString().substring(14, 19);
};
